import React from 'react';
import { createRoot } from 'react-dom/client';
import { toLocale } from '@common/i18n';

import './index.less';

const App = () => {
  const { locale } = window.okGlobal;
  const lang = locale.split('_')[0];
  const config = {
    title: toLocale('tutor_page_title'),
    steps: [
      {
        title: toLocale('tutor_page_step1'),
        imgs: [
          `/cdn/assets/imgs/tutor/tutor-${lang}-1.png`,
          `/cdn/assets/imgs/tutor/tutor-${lang}-2.png`,
        ],
      },
      {
        title: toLocale('tutor_page_step2'),
        imgs: [
          `/cdn/assets/imgs/tutor/tutor-${lang}-3.png`,
          `/cdn/assets/imgs/tutor/tutor-${lang}-4.png`,
        ],
      },
    ],
  };
  return (
    <div className="tutor-box">
      <div className="title">{config.title}</div>
      <div className="content-box">
        {config.steps.map((step, index) => {
          return (
            <section className="step" key={index}>
              <div className="step-order">{index + 1}</div>
              <div className="step-title">{step.title}</div>
              <div className="step-img">
                {step.imgs.map((imgPath) => {
                  return (
                    <img
                      key={imgPath}
                      src={`${window.okGlobal.cdnBaseUrl}${imgPath}`}
                    />
                  );
                })}
              </div>
            </section>
          );
        })}
      </div>
    </div>
  );
};

const root = createRoot(document.getElementById('root'));
root.render(<App />);
